import React from 'react';

interface ExpiryFilterProps {
  currentFilter: 'all' | 'expired' | 'expiring-soon' | 'expiring-month';
  onFilterChange: (filter: 'all' | 'expired' | 'expiring-soon' | 'expiring-month') => void;
  expiryCounts: {
    all: number;
    expired: number;
    expiringSoon: number;
    expiringMonth: number;
  };
}

const ExpiryFilter: React.FC<ExpiryFilterProps> = ({ 
  currentFilter, 
  onFilterChange, 
  expiryCounts 
}) => {
  const filterOptions = [
    { value: 'all' as const, label: '전체', count: expiryCounts.all },
    { value: 'expired' as const, label: '만료됨', count: expiryCounts.expired },
    { value: 'expiring-soon' as const, label: '7일 이내', count: expiryCounts.expiringSoon },
    { value: 'expiring-month' as const, label: '30일 이내', count: expiryCounts.expiringMonth },
  ];

  const getButtonStyle = (filterValue: string) => {
    const isActive = currentFilter === filterValue;
    const baseStyle = "px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 border";
    
    if (isActive) {
      if (filterValue === 'all') {
        return `${baseStyle} bg-blue-600 text-white border-blue-600`;
      } else if (filterValue === 'expired') {
        return `${baseStyle} bg-red-600 text-white border-red-600`;
      } else if (filterValue === 'expiring-soon') {
        return `${baseStyle} bg-orange-600 text-white border-orange-600`;
      } else if (filterValue === 'expiring-month') {
        return `${baseStyle} bg-yellow-600 text-white border-yellow-600`;
      }
    }
    
    return `${baseStyle} bg-white text-gray-700 border-gray-300 hover:bg-gray-50`;
  };

  return (
    <div className="mb-6">
      <div className="flex flex-wrap gap-2">
        {filterOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => onFilterChange(option.value)}
            className={getButtonStyle(option.value)}
          >
            {option.label} ({option.count})
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExpiryFilter; 